module.exports = __webpack_public_path__ + "std/img/ads2.221ea28.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/views/My/Base/components/Ads/images/ads2.webp
// module id = ojKG
// module chunks = 0